var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Box",
    {
      staticClass: "edit-payment",
      attrs: { display: "flex", flexAlign: "start" }
    },
    [
      _c(
        "Box",
        { staticClass: "payment", attrs: { flex: 3 } },
        [
          _vm.payment
            ? _c("FormBuilder", {
                key: _vm.payment.id,
                attrs: {
                  initial: _vm.initial,
                  form: _vm.formDescription,
                  validate: _vm.validate
                },
                on: { submit: _vm.submit },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function({
                        $values,
                        dafInfo,
                        info,
                        details,
                        receipt,
                        iraInfo,
                        matchingGiftInfo
                      }) {
                        return [
                          _c(
                            "Box",
                            { staticClass: "payment-form" },
                            [
                              _c(
                                "Card",
                                [
                                  _c(
                                    "FormSection",
                                    [
                                      _c(
                                        "template",
                                        { slot: "header" },
                                        [
                                          _c(
                                            "Box",
                                            { attrs: { display: "flex" } },
                                            [
                                              _vm._v(
                                                " Payment " +
                                                  _vm._s(
                                                    _vm.payment
                                                      ? "#" +
                                                          _vm.payment.shortId
                                                      : ""
                                                  ) +
                                                  " "
                                              ),
                                              _vm.receiptLink
                                                ? _c(
                                                    "Box",
                                                    {
                                                      staticClass: "manage-menu"
                                                    },
                                                    [
                                                      _c(
                                                        "Popover",
                                                        {
                                                          attrs: {
                                                            width: "150px",
                                                            alignRight: ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "template",
                                                            { slot: "trigger" },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "trigger"
                                                                },
                                                                [
                                                                  _c("Icon", {
                                                                    staticClass:
                                                                      "trigger_icon",
                                                                    attrs: {
                                                                      name:
                                                                        "cog"
                                                                    }
                                                                  })
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "template",
                                                            { slot: "content" },
                                                            [
                                                              _c(
                                                                "ul",
                                                                [
                                                                  _c(
                                                                    "ProtectedBlock",
                                                                    {
                                                                      attrs: {
                                                                        requiredRole:
                                                                          _vm
                                                                            .UserRole
                                                                            .DeletePledgeAndPayment
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "li",
                                                                        {
                                                                          staticClass:
                                                                            "popover-action",
                                                                          on: {
                                                                            click: () =>
                                                                              (_vm.delModal = true)
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "layoutText",
                                                                            {
                                                                              attrs: {
                                                                                fontSize: 1
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "Delete Payment"
                                                                              )
                                                                            ]
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "ProtectedBlock",
                                                                    {
                                                                      attrs: {
                                                                        requiredRole:
                                                                          _vm
                                                                            .UserRole
                                                                            .MovePledgeAndPayment
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "li",
                                                                        {
                                                                          staticClass:
                                                                            "popover-action",
                                                                          on: {
                                                                            click: () =>
                                                                              (_vm.moveModal = true)
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "layoutText",
                                                                            {
                                                                              attrs: {
                                                                                fontSize: 1
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "Move Payment"
                                                                              )
                                                                            ]
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "li",
                                                                    {
                                                                      staticClass:
                                                                        "popover-action"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "a",
                                                                        {
                                                                          attrs: {
                                                                            target:
                                                                              "_blank",
                                                                            href:
                                                                              _vm.receiptLink
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "layoutText",
                                                                            {
                                                                              attrs: {
                                                                                fontSize: 1
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "Generate Receipt"
                                                                              )
                                                                            ]
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "li",
                                                                    {
                                                                      staticClass:
                                                                        "popover-action",
                                                                      on: {
                                                                        click: () =>
                                                                          (_vm.receiptModal = true)
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "layoutText",
                                                                        {
                                                                          attrs: {
                                                                            fontSize: 1
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Email Receipt"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        2
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "template",
                                        { slot: "main" },
                                        [_c(info, { tag: "component" })],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                ],
                                1
                              ),
                              $values.category === _vm.PaymentCategory.DAF
                                ? _c(
                                    "Card",
                                    [
                                      _c(
                                        "FormSection",
                                        [
                                          _c("template", { slot: "header" }, [
                                            _vm._v("Donor Advised Fund")
                                          ]),
                                          _c(
                                            "template",
                                            { slot: "main" },
                                            [_c(dafInfo, { tag: "component" })],
                                            1
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              $values.category === _vm.PaymentCategory.IRA
                                ? _c(
                                    "Card",
                                    [
                                      _c(
                                        "FormSection",
                                        [
                                          _c("template", { slot: "header" }, [
                                            _vm._v("IRA")
                                          ]),
                                          _c(
                                            "template",
                                            { slot: "main" },
                                            [_c(iraInfo, { tag: "component" })],
                                            1
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              $values.category ===
                              _vm.PaymentCategory.MatchingGift
                                ? _c(
                                    "Card",
                                    [
                                      _c(
                                        "FormSection",
                                        [
                                          _c("template", { slot: "header" }, [
                                            _vm._v("MatchingGift")
                                          ]),
                                          _c(
                                            "template",
                                            { slot: "main" },
                                            [
                                              _c(matchingGiftInfo, {
                                                tag: "component"
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "Card",
                                [
                                  _c(
                                    "FormSection",
                                    [
                                      _c("template", { slot: "header" }, [
                                        _vm._v("Receipt")
                                      ]),
                                      _c(
                                        "template",
                                        { slot: "main" },
                                        [
                                          _c(receipt, { tag: "component" }),
                                          _c(
                                            "layoutFormRow",
                                            { staticClass: "inlineLabel" },
                                            [
                                              _c("UILabel", {
                                                attrs: {
                                                  text: "Last receipt date"
                                                }
                                              }),
                                              _c(
                                                "layoutText",
                                                {
                                                  staticStyle: {
                                                    "margin-top": "4px"
                                                  },
                                                  attrs: { fontSize: "2" }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.payment &&
                                                          _vm.payment
                                                            .receiptSent
                                                          ? _vm.formatDate(
                                                              _vm.payment
                                                                .receiptSent
                                                            )
                                                          : "Never sent"
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                ],
                                1
                              ),
                              _c(
                                "Card",
                                [
                                  _c(
                                    "FormSection",
                                    [
                                      _c("template", { slot: "header" }, [
                                        _vm._v("Payment Details")
                                      ]),
                                      _c(
                                        "template",
                                        { slot: "main" },
                                        [
                                          _c(details, { tag: "component" }),
                                          _c("PaymentSourceDetails", {
                                            attrs: {
                                              sourceEvidence:
                                                _vm.payment &&
                                                _vm.payment.sourceEvidence,
                                              channel:
                                                _vm.payment &&
                                                _vm.payment.channel
                                            }
                                          }),
                                          _vm.payment && _vm.payment.referrer
                                            ? _c(
                                                "layoutFormRow",
                                                { staticClass: "inlineLabel" },
                                                [
                                                  _c("UILabel", {
                                                    attrs: { text: "Web Site" }
                                                  }),
                                                  _c(
                                                    "layoutText",
                                                    {
                                                      staticStyle: {
                                                        "margin-top": "4px"
                                                      },
                                                      attrs: { fontSize: "2" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.getReferrerHost()
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                ],
                                1
                              ),
                              _c(
                                "Card",
                                [
                                  _c(
                                    "FormSection",
                                    [
                                      _c("template", { slot: "header" }, [
                                        _vm._v("Pledges")
                                      ]),
                                      _c(
                                        "template",
                                        { slot: "main" },
                                        [
                                          _vm.payment &&
                                          _vm.payment.applications
                                            ? _c(
                                                "UITable",
                                                {
                                                  staticClass:
                                                    "condensed clear-header noHover"
                                                },
                                                [
                                                  _c(
                                                    "TableHead",
                                                    [
                                                      _c(
                                                        "TableRow",
                                                        [
                                                          _c("TableHeader", [
                                                            _vm._v("Department")
                                                          ]),
                                                          _c("TableHeader", [
                                                            _vm._v("Campaign")
                                                          ]),
                                                          _c("TableHeader", [
                                                            _vm._v("Amount")
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "TableBody",
                                                    _vm._l(
                                                      _vm.payment.applications,
                                                      function(app, idx) {
                                                        return _c(
                                                          "TableRow",
                                                          { key: idx },
                                                          [
                                                            _c("TableCell", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.startCase(
                                                                    app.department
                                                                  )
                                                                )
                                                              )
                                                            ]),
                                                            _c("TableCell", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  app.campaign &&
                                                                    app.campaign
                                                                      .label
                                                                )
                                                              )
                                                            ]),
                                                            _c(
                                                              "TableCell",
                                                              {
                                                                staticClass:
                                                                  "amount-cell"
                                                              },
                                                              [
                                                                _c(
                                                                  "AmountWithCurrency",
                                                                  {
                                                                    attrs: {
                                                                      value: {
                                                                        amount:
                                                                          app.originalAmount ||
                                                                          app.amount,
                                                                        currency:
                                                                          app.currency ||
                                                                          null
                                                                      },
                                                                      isCurrencyChangeable: false,
                                                                      date: _vm.payment
                                                                        ? _vm.dateScalarToDate(
                                                                            _vm
                                                                              .payment
                                                                              .date
                                                                          )
                                                                        : new Date(),
                                                                      originalDate:
                                                                        _vm.originalDate,
                                                                      originalValue:
                                                                        app.originalAmount,
                                                                      "show-tooltip": false
                                                                    },
                                                                    on: {
                                                                      input: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.updateApplicationValue(
                                                                          app,
                                                                          $event,
                                                                          $values
                                                                        )
                                                                      }
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                ],
                                1
                              ),
                              _vm.payment
                                ? _c(
                                    "Card",
                                    [
                                      _c(
                                        "FormSection",
                                        [
                                          _c("template", { slot: "header" }, [
                                            _vm._v("Audit")
                                          ]),
                                          _c(
                                            "template",
                                            { slot: "main" },
                                            [
                                              _c("SmallPaymentAuditLog", {
                                                attrs: {
                                                  paymentId: _vm.payment.id
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "UIButton",
                                {
                                  staticClass: "submit-btn",
                                  attrs: { disabled: _vm.processing }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.processing ? "Submitting" : "Submit"
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      }
                    },
                    {
                      key: "amount-value",
                      fn: function({ listeners, value, values, errors }) {
                        return [
                          _c(
                            "div",
                            [
                              _c(
                                "AmountWithCurrency",
                                _vm._g(
                                  _vm._b(
                                    {
                                      attrs: {
                                        date: _vm.dateScalarToDate(values.date),
                                        originalDate: _vm.originalDate,
                                        isCurrencyChangeable: false,
                                        originalValue: _vm.originalAmount,
                                        convertedAmount: values.convertedAmount
                                      }
                                    },
                                    "AmountWithCurrency",
                                    { value },
                                    false
                                  ),
                                  listeners
                                )
                              ),
                              errors("amount")
                                ? _c("span", { staticClass: "error-label" }, [
                                    _vm._v(_vm._s(errors("amount")))
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      }
                    },
                    {
                      key: "batch-date",
                      fn: function({ values }) {
                        return [
                          _c(
                            "layoutText",
                            {
                              key: values.batch.id,
                              staticStyle: { "margin-top": "4px" },
                              attrs: { fontSize: "2" }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    values.batchDate
                                      ? _vm.formatDate(values.batchDate)
                                      : ""
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ]
                      }
                    },
                    {
                      key: "checkScan",
                      fn: function({ value, listeners, values }) {
                        return [
                          _c(
                            "Box",
                            [
                              value && value.status === "failed"
                                ? _c("div", { staticClass: "scan-error" }, [
                                    _vm._v("Error uploading file")
                                  ])
                                : _vm._e(),
                              value && value.file
                                ? _c(
                                    "Box",
                                    { staticClass: "image-box" },
                                    [
                                      _c("GetSignedUrl", {
                                        attrs: { filename: value.file },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function({ url }) {
                                                return [
                                                  _c("img", {
                                                    attrs: { src: url }
                                                  })
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      }),
                                      _c(
                                        "ProtectedBlock",
                                        {
                                          attrs: {
                                            requiredRole:
                                              _vm.UserRole.CheckPaymentEdit
                                          }
                                        },
                                        [
                                          value && value.file
                                            ? _c(
                                                "UIButton",
                                                {
                                                  staticClass: "smaller del",
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      $event.preventDefault()
                                                      return listeners.input(
                                                        null
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("Delete")]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "ProtectedBlock",
                                {
                                  attrs: {
                                    requiredRole: _vm.UserRole.CheckPaymentEdit
                                  }
                                },
                                [
                                  _c(
                                    "S3Uploader",
                                    _vm._g(
                                      {
                                        attrs: {
                                          location: `checks/${values.id}`
                                        }
                                      },
                                      listeners
                                    )
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1500450918
                )
              })
            : _vm._e()
        ],
        1
      ),
      _vm.payment && _vm.showAudit
        ? _c(
            "Box",
            { attrs: { marginLeft: 5, flex: 1 } },
            [
              _c(
                "Card",
                [
                  _c(
                    "FormSection",
                    [
                      _c("template", { slot: "header" }, [_vm._v("Audit")]),
                      _c(
                        "template",
                        { slot: "main" },
                        [
                          _c("SmallPaymentAuditLog", {
                            attrs: { paymentId: _vm.payment.id }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "Modal",
        {
          attrs: {
            width: "450px",
            top: "250px",
            showCloseText: false,
            show: _vm.isVoidModalVisible,
            requestClose: _vm.hideVoidModal,
            closeOnOutClick: true
          }
        },
        [
          [
            _c("VoidModal", {
              on: {
                close: _vm.hideVoidModal,
                submit: function($event) {
                  return _vm.onVoidModalSubmit($event)
                }
              }
            })
          ]
        ],
        2
      ),
      _c("Modal", {
        attrs: {
          show: _vm.delModal,
          width: "400px",
          top: "100px",
          requestClose: () => (_vm.delModal = false)
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function({}) {
              return [
                _c(
                  "Box",
                  { attrs: { padding: 5 } },
                  [
                    _c(
                      "Box",
                      { attrs: { tag: "header", marginBottom: 5 } },
                      [
                        _c(
                          "layoutText",
                          {
                            attrs: {
                              fontUppercase: "",
                              fontSize: 3,
                              fontWeight: "bold",
                              color: "#222"
                            }
                          },
                          [_vm._v("Delete Payment")]
                        )
                      ],
                      1
                    ),
                    _c(
                      "Box",
                      [
                        _c(
                          "layoutFormRow",
                          { staticClass: "inlineLabel manage-check" },
                          [
                            _c("UICheckBox", {
                              attrs: {
                                labelText: "Include associated pledges"
                              },
                              model: {
                                value: _vm.withPledges,
                                callback: function($$v) {
                                  _vm.withPledges = $$v
                                },
                                expression: "withPledges"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "layoutFormRow",
                          { staticClass: "inlineLabel" },
                          [
                            _c(
                              "UIButton",
                              {
                                staticClass: "red",
                                on: { click: _vm.onDeletePayment }
                              },
                              [_vm._v("Delete this payment")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _c("Modal", {
        attrs: {
          show: _vm.moveModal,
          width: "400px",
          top: "100px",
          requestClose: _vm.closeModal
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function({}) {
              return [
                _c(
                  "Box",
                  { attrs: { padding: 5 } },
                  [
                    _c(
                      "Box",
                      { attrs: { tag: "header", marginBottom: 5 } },
                      [
                        _c(
                          "layoutText",
                          {
                            attrs: {
                              fontUppercase: "",
                              fontSize: 3,
                              fontWeight: "bold",
                              color: "#222"
                            }
                          },
                          [_vm._v("Move Payment to")]
                        )
                      ],
                      1
                    ),
                    _c(
                      "Box",
                      [
                        _c(
                          "layoutFormRow",
                          { staticClass: "inlineLabel" },
                          [
                            _c(
                              "Box",
                              { attrs: { flex: 1 } },
                              [
                                _c("DonorLookup", {
                                  staticClass: "donor-lookup",
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value: _vm.selectedDonor,
                                    callback: function($$v) {
                                      _vm.selectedDonor = $$v
                                    },
                                    expression: "selectedDonor"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "layoutFormRow",
                          { staticClass: "inlineLabel manage-check" },
                          [
                            _c("UICheckBox", {
                              attrs: {
                                labelText: "Include associated pledges"
                              },
                              model: {
                                value: _vm.withPledges,
                                callback: function($$v) {
                                  _vm.withPledges = $$v
                                },
                                expression: "withPledges"
                              }
                            })
                          ],
                          1
                        ),
                        _c("UIButton", { on: { click: _vm.onMovePayment } }, [
                          _vm._v("Submit")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _c("Modal", {
        attrs: {
          show: _vm.receiptModal,
          width: "1300px",
          top: "100px",
          requestClose: _vm.closeModal
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function({}) {
              return [
                _c(
                  "ReceiptPreview",
                  _vm._b(
                    { on: { done: _vm.closeModal } },
                    "ReceiptPreview",
                    _vm.receiptPreviewProps,
                    false
                  )
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }